// Page d'accueil de la porte abracadabati.com
// Connecté (ordinateur) : le cockpit particulier s'ouvre directement avec
// l'accueil AbracadaBati dans la zone blanche (menu bleu ouvert à gauche).
// Visiteur non connecté ou mobile : la vitrine classique.
// Les portes pro (vitrine ET cockpit) sont rendues DIRECTEMENT ici, sans
// redirection — c'est ce qui garantit le zéro flash à l'arrivée.
import HomePage from '../pages/HomePage';
import EspaceProLandingPage from '../pages/espacepro/EspaceProLandingPage';
import CockpitParticulierLayout from '../pages/cockpit-particulier/CockpitParticulierLayout';
import CockpitProLayout from '../pages/cockpit-pro/CockpitProLayout';
import { useTenant } from '../context/TenantContext';

export default function AccueilPorteBati() {
  const tenant = useTenant();
  const desktop = typeof window !== 'undefined' && window.innerWidth >= 768;

  // Porte vitrine pro (abracada.pro) : la vitrine EST la page d'accueil —
  // rendu direct, aucune redirection, donc aucun flash
  if (tenant.vitrinePro) {
    return <EspaceProLandingPage />;
  }

  // Porte cockpit pro (app.abracada.pro, pro.abracadabati.com) : le cockpit
  // EST la page d'accueil — même remède zéro flash que la vitrine
  if (tenant.proDirect) {
    return <CockpitProLayout />;
  }

  // Porte bâti, ordinateur : le cockpit particulier pour TOUT LE MONDE,
  // connecté ou non (décision Romain 11/06). Mobile : accueil vitrine actuel.
  // La zone blanche s'ouvre EN GRAND pour tous (menu bleu replié en bande
  // d'icônes, un clic le rouvre) — connecté, déconnecté ou mode visiteur.
  if (tenant.id === 'bati' && desktop) {
    return (
      <CockpitParticulierLayout
        contexteInitial="page_accueil_bati"
        sidebarReplieeInitiale={true}
      />
    );
  }
  return <HomePage />;
}
